import { useMutation } from "react-query";
import Axios from "axios";
import { ResourceInactivityResponseDto } from "../../../features/Schedule/typings/resource-calendar.types";
import type { ResourceCalendarByObjectRequest } from "../../../features/Schedule/utils/resource-booking-schedule.utils";

export type ResourceInactivityByObjectParams = ResourceCalendarByObjectRequest;

export function useRemoteResourceInactivityByBookingObjectMutation() {
  return useMutation({
    mutationFn: async (
      params: ResourceInactivityByObjectParams
    ): Promise<ResourceInactivityResponseDto> => {
      const { data } = await Axios.get<ResourceInactivityResponseDto>(
        "/booking-schedule/inactivity-by-booking-object",
        { params }
      );
      return data;
    }
  });
}
